import { ITrxnReceipts } from "Views/Transaction/@types";

export const getReceiptsUrls = (receipts: ITrxnReceipts[]) => {
  return Array.isArray(receipts) && receipts.length > 0 ? receipts.map((receipt) => receipt.url) : [];
};
